import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { LinkButton } from './ui/Button';
import { WhatsAppIcon } from './ui/WhatsAppIcon';
import { waLink } from '../utils/whatsapp';
const navItems = [{
  label: 'Tratamientos',
  href: '#tratamientos'
}, {
  label: 'Nuestro enfoque',
  href: '#enfoque'
}, {
  label: 'Equipo',
  href: '#equipo'
}, {
  label: 'Reseñas',
  href: '#resenas'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-[900] w-full transition-all duration-300 ${scrolled ? 'bg-white shadow-nav' : 'bg-transparent'}`} data-id="element-164" data-mp="1pxi2a98gotry">
      <div className="mx-auto flex h-[60px] max-w-shell items-center justify-between px-5 lg:h-[72px] lg:px-[120px]" data-id="element-165" data-mp="9opypi81ux4t">
        <a href="#top" className="flex flex-col leading-none" data-id="element-166" data-mp="emrh00xnisf8">
          <span className="font-display text-[19px] font-bold text-primary lg:text-[21px]" data-id="element-167" data-mp="epdpq3wa3dz1">Sonrisa Clara</span>
          <span className="mt-[2px] font-sans text-[11px] font-normal text-muted" data-id="element-168" data-mp="olqd6k18cvlc">Odontología moderna</span>
        </a>

        <nav aria-label="Navegación principal" className="hidden items-center gap-6 lg:flex xl:gap-8" data-id="element-169" data-mp="3n3vy66q4svj6">
          {navItems.map(item => <a key={item.href} href={item.href} className="font-sans text-[15px] font-medium text-ink transition-colors hover:text-secondary" data-id="element-170" data-mp="3s2qi5bzu4q4v">
              {item.label}
            </a>)}
        </nav>

        <div className="hidden flex-col items-center lg:flex" data-id="element-171" data-mp="34dnzc0tgsr8s">
          <LinkButton variant="whatsapp" size="sm" href={waLink('Hola, vi la página de Sonrisa Clara y quisiera agendar una valoración odontológica.')} target="_blank" rel="noreferrer" className="font-bold" data-id="element-172" data-mp="39bzb4h3blbtn">
            <WhatsAppIcon className="h-4 w-4" data-id="element-173" data-mp="3b1mb3ymwmb3d" />
            Agendar por WhatsApp
          </LinkButton>
          <span className="mt-[6px] font-sans text-[11px] text-muted" data-id="element-174" data-mp="361q73ze7ijnt">Respuesta en horario de atención</span>
        </div>

        <button type="button" onClick={() => setOpen(prev => !prev)} aria-expanded={open} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="rounded-lg p-2 text-primary transition-colors hover:bg-primary/5 lg:hidden" data-id="element-175" data-mp="2id70doat2exu">
          {open ? <XIcon className="h-6 w-6" data-id="element-176" data-mp="2napb9k8dv48h" /> : <MenuIcon className="h-6 w-6" data-id="element-177" data-mp="2ndladbvyvyyi" />}
        </button>
      </div>

      {open && <div className="border-t border-hairline bg-white px-5 py-4 lg:hidden" data-id="element-178" data-mp="7ijbuag4619b">
          <nav aria-label="Navegación móvil" className="flex flex-col" data-id="element-179" data-mp="2khrznav5xws">
            {navItems.map(item => <a key={item.href} href={item.href} onClick={() => setOpen(false)} className="border-b border-hairline py-3 font-sans text-[15px] font-medium text-ink last:border-0" data-id="element-180" data-mp="a3h9fnerlfdi">
                {item.label}
              </a>)}
          </nav>
          <LinkButton variant="whatsapp" size="sm" href={waLink('Hola, vi la página de Sonrisa Clara y quisiera agendar una valoración odontológica.')} target="_blank" rel="noreferrer" className="mt-4 w-full" data-id="element-181" data-mp="sva6bswyfkqi">
            <WhatsAppIcon className="h-4 w-4" data-id="element-182" data-mp="o3s2mx3jr61u" />
            Agendar por WhatsApp
          </LinkButton>
          <p className="mt-2 text-center font-sans text-[11px] text-muted" data-id="element-183" data-mp="1btw2quhj0no3">Respuesta en horario de atención</p>
        </div>}
    </header>;
}